export default "__VITE_ASSET__24175f52__"